export default __webpack_public_path__ + "images/cancerfonden_logo.png";